import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Info } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogDescription,
} from '@/components/ui/dialog';
import { useApp } from '@/context/AppContext';

export const Footer = () => {
  const { t } = useApp();
  const currentYear = new Date().getFullYear();

  return (
    <motion.footer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.5 }}
      className="w-full bg-card border-t border-border/50 mt-auto"
    >
      <div className="container mx-auto px-4 py-8">
        {/* Logos Section */}
        <div className="flex flex-wrap justify-center items-center gap-12 mb-8 pb-8 border-b border-border/30">
          <div className="flex items-center justify-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_alzatuvoz-app/artifacts/te2uikkj_lab-logo%20final%20ajustado.png" 
              alt="LAB XXI" 
              className="h-16 w-auto object-contain"
            />
          </div>
          <div className="flex items-center justify-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_alzatuvoz-app/artifacts/boo9jzi9_IMG_2074%20603%20x%20449.PNG" 
              alt="Alza Tu Voz" 
              className="h-16 w-auto object-contain"
            />
          </div>
        </div>

        {/* Credits and Links */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Heart className="h-4 w-4 text-destructive" />
            <span>{t('footerCopyright', { year: currentYear })}</span>
          </div>

          <div className="flex items-center gap-4">
            <Dialog>
              <DialogTrigger asChild>
                <Button variant="ghost" size="sm" className="text-muted-foreground hover:text-foreground">
                  <Info className="h-4 w-4 mr-2" />
                  {t('viewCredits')}
                </Button>
              </DialogTrigger>
              <DialogContent className="sm:max-w-md bg-card rounded-2xl">
                <DialogHeader>
                  <DialogTitle className="text-xl font-bold text-foreground">
                    {t('creditsTitle')}
                  </DialogTitle>
                  <DialogDescription className="sr-only">
                    Información de créditos del proyecto
                  </DialogDescription>
                </DialogHeader>
                <div className="space-y-6 py-4">
                  <div className="space-y-4">
                    <div className="flex items-center gap-4 p-4 bg-muted/50 rounded-2xl">
                      <div className="w-14 h-14 rounded-xl flex items-center justify-center overflow-hidden">
                        <img 
                          src="https://customer-assets.emergentagent.com/job_alzatuvoz-app/artifacts/te2uikkj_lab-logo%20final%20ajustado.png" 
                          alt="LAB XXI" 
                          className="h-12 w-auto object-contain"
                        />
                      </div>
                      <div>
                        <h4 className="font-semibold text-foreground">LAB XXI</h4>
                        <p className="text-sm text-muted-foreground">Metodología y contenido</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-4 p-4 bg-muted/50 rounded-2xl">
                      <div className="w-14 h-14 rounded-xl flex items-center justify-center overflow-hidden">
                        <img 
                          src="https://customer-assets.emergentagent.com/job_alzatuvoz-app/artifacts/boo9jzi9_IMG_2074%20603%20x%20449.PNG" 
                          alt="Alza Tu Voz" 
                          className="h-12 w-auto object-contain"
                        />
                      </div>
                      <div>
                        <h4 className="font-semibold text-foreground">Alza Tu Voz</h4>
                        <p className="text-sm text-muted-foreground">Proyecto de participación adolescente</p>
                      </div>
                    </div>
                  </div>
                  <p className="text-center text-sm text-muted-foreground">
                    {t('credits')}
                  </p>
                </div>
              </DialogContent>
            </Dialog>
          </div>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;
